import { createFileRoute } from '@tanstack/react-router'
import { NotificationForm } from '@/features/notifications/components/notification-form'

export const Route = createFileRoute('/_authenticated/notifications/new')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col gap-4 p-4">
      <h1 className="text-xl font-semibold">Nuova notifica</h1>
      <NotificationForm />
    </div>
  )
}
